if (!customElements.get('delayed-message')) {
  customElements.define(
    'delayed-message',
    class DelayedMessage extends HTMLElement {
      constructor() {
        super();
        this.id = this.getAttribute('data-id') || '';
        this.delay = parseInt(this.getAttribute('data-delay') || '1000');
        if (!this.classList.contains('hidden')) this.waitVisible();
      }

      connectedCallback() {
        document.addEventListener('DELAYED_MESSAGE:SHOW', this.onShowMessage.bind(this));
        document.addEventListener('DELAYED_MESSAGE:HIDE', this.onHideMessage.bind(this));
      }

      disconnectedCallback() {
        document.removeEventListener('DELAYED_MESSAGE:SHOW', this.onShowMessage.bind(this));
        document.removeEventListener('DELAYED_MESSAGE:HIDE', this.onHideMessage.bind(this));
      }

      onHideMessage(event) {
        this.hideMessage();
      }

      onShowMessage(event) {
        if (event.detail && event.detail.id && event.detail.id == this.id) {
          this.showMessage(event.detail.type, event.detail.message);
        }
      }

      waitVisible() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          this.delayHideMessage();
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
      }

      showMessage(type = 'errors', message = '') {
        this.classList.remove('hidden');
        this.querySelectorAll(`[data-type="${type}"]`).forEach((element) => {
          element.classList.remove('hidden');
          if (message) {
            if (typeof message === 'object') {
              //
              message = Object.values(message);
            }
            element.innerHTML = message;
          }
        });
        this.delayHideMessage();
      }

      delayHideMessage() {
        setTimeout(() => {
          this.hideMessage();
        }, this.delay);
      }

      hideMessage() {
        this.classList.add('hidden');
        this.querySelectorAll('[data-type]').forEach((element) => element.classList.add('hidden'));
      }
    },
  );
}
